module.exports = __webpack_public_path__ + "static/media/img-0c90fd9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/wr-logo.png
// module id = 5307
// module chunks = 39